import { render, staticRenderFns } from "./website-training-form.vue?vue&type=template&id=5c50bc51&scoped=true"
import script from "./website-training-form.vue?vue&type=script&lang=js"
export * from "./website-training-form.vue?vue&type=script&lang=js"
import style0 from "./website-training-form.vue?vue&type=style&index=0&id=5c50bc51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c50bc51",
  null
  
)

export default component.exports